// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.glossary-term {
  text-decoration: underline;
  text-decoration-style: dotted;
  text-decoration-thickness: 1px;
  text-decoration-color: #525252;
  text-underline-offset: 3px;
  cursor: help;
  position: relative;
  display: inline-block;
}

.glossary-popup-portal {
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  width: 100%;
  height: 0;
  pointer-events: none;
}

.glossary-popup {
  position: absolute;
  background-color: #faf8f5;
  border-radius: 8px;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.1);
  padding: 12px;
  width: 300px;
  font-family: "Crimson", serif;
  font-size: 14px;
  border: 1px solid rgba(135, 134, 127, 0.25);
  pointer-events: auto;
}

.glossary-type {
  color: #df2d11;
  font-size: 12px;
  text-transform: uppercase;
  font-family: "Gabarito", serif;
  margin-bottom: 4px;
}

.glossary-definition {
  color: #454545;
  line-height: 1.4;
}

.glossary-formula {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(135, 134, 127, 0.25);
  color: #525252;
  font-family: "Gabarito", serif;
  font-size: 12px;
}

.glossary-formula span {
  color: #df2d11;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/components/GlossaryTerm.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,8BAA8B;EAC9B,8BAA8B;EAC9B,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,OAAO;EACP,MAAM;EACN,WAAW;EACX,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,+CAA+C;EAC/C,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+CAA+C;EAC/C,cAAc;EACd,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".glossary-term {\n  text-decoration: underline;\n  text-decoration-style: dotted;\n  text-decoration-thickness: 1px;\n  text-decoration-color: #525252;\n  text-underline-offset: 3px;\n  cursor: help;\n  position: relative;\n  display: inline-block;\n}\n\n.glossary-popup-portal {\n  position: fixed;\n  z-index: 9999;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 0;\n  pointer-events: none;\n}\n\n.glossary-popup {\n  position: absolute;\n  background-color: #faf8f5;\n  border-radius: 8px;\n  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.1);\n  padding: 12px;\n  width: 300px;\n  font-family: \"Crimson\", serif;\n  font-size: 14px;\n  border: 1px solid rgba(135, 134, 127, 0.25);\n  pointer-events: auto;\n}\n\n.glossary-type {\n  color: #df2d11;\n  font-size: 12px;\n  text-transform: uppercase;\n  font-family: \"Gabarito\", serif;\n  margin-bottom: 4px;\n}\n\n.glossary-definition {\n  color: #454545;\n  line-height: 1.4;\n}\n\n.glossary-formula {\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid rgba(135, 134, 127, 0.25);\n  color: #525252;\n  font-family: \"Gabarito\", serif;\n  font-size: 12px;\n}\n\n.glossary-formula span {\n  color: #df2d11;\n  font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
